import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';

@Pipe({
    name: 'millionPipe',
    standalone: false
})
@Injectable({ providedIn: 'root' }) // <-- This is important
export class MillionPipe implements PipeTransform {
   transform(value: any, marketCap?: boolean): any {
      // Convert value to a number
      value = +value;

      // Return dash if value is -1 or not a number
      if (value === -1 || isNaN(value)) return '-';

      // Apply marketCap conversion if flag is true
      if (marketCap) {
         value = value * 1000000;
      }

      // Format the number (e.g., 123456.789 -> "123456.79")
      value = formatNumber(value, 'en-US', '1.2-2').replace(/,/g, '');

      // Convert to number again after formatting to ensure correct comparison
      const numericValue = +value;

      if (numericValue < 10000) {
         return value;
      }
      if (numericValue >= 10000 && numericValue < 1000000) {
         return (numericValue / 1000).toFixed(2) + 'K';
      }
      if (numericValue >= 1000000 && numericValue < 1000000000) {
         return (numericValue / 1000000).toFixed(2) + 'M';
      }
      if (numericValue >= 1000000000 && numericValue < 1000000000000) {
         return (numericValue / 1000000000).toFixed(2) + 'B';
      }
      return (numericValue / 1000000000000).toFixed(2) + 'T';
   }
}
